export default __webpack_public_path__ + "static/media/Pickpocket's Mask of the Burning Temple.92830906.jpg";